import { DateUtils } from './DateUtils';
import { EntryPoint } from '../models';

export const ErrorUtils = {
    // TODO: refactor error keys to an object of consts
    getLocationErrorKey(validationError, activeProduct) {
        const errorKey = validationError ? validationError.error : null;
        const productSelector = activeProduct === EntryPoint.HOTELS ? 'home.hsaSelector' : 'airportSelector';
        return {
            empty: `${productSelector}.incomplete_msg`,
            samecity: 'citySearch.same_location_error',
            inspirational: 'inspirational.autocomplete.error.dynpack',
        }[errorKey];
    },

    getDatesErrorKey(validationError) {
        const errorKey = validationError ? validationError.error : null;
        return {
            empty: 'calendar.incomplete',
            incomplete_roundtrip: 'flightsManager.error.dates',
            hotels_min_date: 'search.minStay.error',
            hotels_max_date: 'search.maxStay.error',
            separatestay_min_date: 'flightsManager.accommodation.atLeastOneDay',
            separatestay_max_date: 'flightsManager.accommodation.maxThirtyDays',
        }[errorKey];
    },

    getDatesErrorKeyArgs(validationError) {
        const errorKey = validationError ? validationError.error : null;
        return {
            hotels_max_date: { number: DateUtils.MAX_DAYS_PRIME_HOTEL },
        }[errorKey];
    },
};
